import PermissionRoute from 'components/PermissionRoute';
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import NotFound from 'scenes/NotFound';
import NewEditProductV2 from 'v2/components/Pages/Product/Edit';

import EditProduct from './EditProduct';
import MyProducts from './MyProducts';
import NewProduct from './NewProduct';
import FreightVinculation from './NewProduct/components/Vinculate';

const Product = () => {
  const base = '/producer/product';
  return (
    <Switch>
      <Redirect exact to={`${base}/myproducts`} path={base} />
      <PermissionRoute
        action='myeduzz:meus-produtos:editar'
        path={`${base}/edit/:productId/:variationId?/:tabName(general|sales|coproducers|affiliates|delivery)?`}
        component={NewEditProductV2}
      />
      <PermissionRoute
        action='myeduzz:meus-produtos:editar'
        path={`${base}/editproduct/:productId/:variationId?/:tabName(general|sales|coproducers|affiliates|delivery|infodelivery|physicaldelivery)?`}
        component={EditProduct}
      />
      <PermissionRoute action='myeduzz:meus-produtos:visualizar' path={`${base}/myproducts/:tab(approved|reproved)?`} component={MyProducts} />
      <PermissionRoute action='myeduzz:meus-produtos:criar' path={`${base}/newproduct`} component={NewProduct} />
      <Route path={`${base}/freight/vinculate`} component={FreightVinculation} />
      <Route path='*' component={NotFound} />
    </Switch>
  );
};
export default Product;
